<template>
    <span><template v-if="sign">{{ formattedSign }} </template>{{ formatted }} {{ currency }}</span>
</template>

<style lang="scss" scoped>
    @import "../../sass/common/variables";

    span {
        font-family: $font-family-number;
    }
</style>

<script>

    export default {

        props: {
            value: {
                type: Number|String,
                required: true
            },
            currency: {
                type: String,
                required: false,
                default: '€'
            },
            sign: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        computed: {
            formatted: function () {
                let value = Number(this.value)

                if(this.sign && value < 0) {
                    value = value*-1;
                }

                return value.toLocaleString()
            },
            formattedSign: function() {
                return this.value > 0 ? '+' : '-'
            }
        }
    }
</script>
